import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import SermonCard from "../components/SermonCard";

export default function Library() {
  const [sermons, setSermons] = useState([]);
  const [series, setSeries] = useState([]);
  const [q, setQ] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const activeSerie = searchParams.get("serie") || "";

  const load = async () => {
    const r = await api.get("/sermons", { params: { q, series: activeSerie } });
    setSermons(r.data);
  };

  useEffect(() => {
    api.get("/sermons/series").then((r) => setSeries(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    const t = setTimeout(load, 180);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, activeSerie]);

  const setSerie = (s) => {
    const next = new URLSearchParams(searchParams);
    if (s) next.set("serie", s); else next.delete("serie");
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20" data-testid="library-page">
      <div className="eyebrow mb-3 reveal">Biblioteca</div>
      <h1 className="hero-headline text-[44px] sm:text-6xl lg:text-[80px] mb-10 reveal reveal-2">
        Todas las<br /><span className="text-[#A36A00]">prédicas</span>
      </h1>
      <div className="relative mb-6 reveal reveal-3">
        <Search size={22} className="absolute left-5 top-1/2 -translate-y-1/2 text-[#55594F]" />
        <input
          className="input-dark pl-14 text-base"
          placeholder="Buscar por tema, versículo o título…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          data-testid="library-search"
        />
      </div>
      {series.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-10 reveal reveal-4" data-testid="series-filters">
          <button
            onClick={() => setSerie("")}
            className={`pill pill-sm ${activeSerie === "" ? "pill-primary" : "pill-outline"}`}
            data-testid="filter-all"
          >
            Todas
          </button>
          {series.map((s) => (
            <button
              key={s}
              onClick={() => setSerie(s)}
              className={`pill pill-sm ${activeSerie === s ? "pill-primary" : "pill-outline"}`}
              data-testid={`filter-${s}`}
            >
              {s}
            </button>
          ))}
        </div>
      )}
      {sermons.length > 0 ? (
        <div className="grid gap-4">
          {sermons.map((s) => <SermonCard key={s.id} s={s} variant="row" />)}
        </div>
      ) : (
        <div className="p-card p-10 text-center text-[#55594F] text-base">No encontramos prédicas con esos criterios.</div>
      )}
    </div>
  );
}
